module.exports = __webpack_public_path__ + "img/st3.cf2e211c.png";